import axios from 'axios';
import { metaCaching } from '../../modules/utils/MetaData';

export const ServiceRequestApi = {
  loadMetaData: metaDataKey => metaCaching(`/api/public/metadata/${metaDataKey}`),
  loadData: id => axios.get(`/api/self/request_form/${id}`),
  createRequestForm: values => axios.post('/api/self/request_form', values),
  updateRequestForm: values => axios.put('/api/public/passport/request_form', values),
  serviceProvider: filter =>
    axios.get(`/api/public/info/paging/service_provider?filter=${filter}`),
  searchGbdfl: iin => axios.get(`/api/info/gbdfl_personal_data/${iin}`),
  searchKindergartenQueue: (childIin, queuedType) =>
    axios.get(
      `/api/public/info/kindergarten_queue/related_entities?childIin=${childIin}&queuedType=${queuedType}`
    ),
  searchVoucherQueue: (childIin, queuedType) =>
    axios.get(
      `/api/public/info/kindergarten_voucher/current?childIin=${childIin}&queuedType=${queuedType}`
    ),
  getSignString: data => axios.post(`/api/info/signature/sign_string/request_form`, data),
  getUniversities: iin =>
    axios.get(
      `/api/public/data/nedb/common_university_education_student_data_by_iin?iin=${iin}`
    ),
  getSchools: iin =>
    axios.get(`/api/public/data/nedb/common_school_student_data_by_iin?iin=${iin}`),
  getColleges: iin =>
    axios.get(
      `/api/public/data/nedb/common_college_education_student_data_by_iin?iin=${iin}`
    ),
  getGuardianship: iin =>
    axios.get(`/api/public/data/nedb/guardianship_data_by_student_iin?iin=${iin}`),
  searchGBDUL: bin => axios.get(`/api/info/gbdul_organization_data/${bin}`),
  checkQueueByIin: (childIin, queuedType) =>
    axios.get(
      `/api/public/info/current/kindergarten_queue?childIin=${childIin}&queuedType=${queuedType}`
    ),
  getDirection: filter => axios.get(`/api/public/info/paging/direction?filter=${filter}`),
  checkActiveQueue: (childIin, queuedType) =>
    axios.get(
      `/api/public/info/current/kindergarten_voucher_queue/request?childIin=${childIin}&queuedType=${queuedType}`
    ),
  getPersonFlBy: iin => axios.get(`api/public/data/person_fl_by_iin?iin=${iin}`),
  getContingentCheck: iin =>
    axios.get(`api/public/info/current/contingent?childIin=${iin}`),
  checkVoucherQueueByIin: filter =>
    axios.get(`api/public/info/order/kindergarten_voucher_queue?filter=${filter}`),
  getVoucherStatus: filter =>
    axios.get(`api/self/paging/kindergarten_voucher?filter=${filter}`),
  getChildrenFromZags: () => axios.get(`api/public/integration/children_from_zags`),
  getChildrenFromIntegration: () =>
    axios.get(`api/public/integration/children_from_zags_and_connected`),
  checkZagsIntegration: () => axios.get(`api/public/integration/check_zags_integration`),
  waitingListConfirmInterest:values => axios.post('/api/public/transitions/kindergarten_voucher_waiting_list/confirm_interest', values),
  getVerifyRequestAddress: (queuedRegion) =>
    axios.get(
      `/api/public/transitions/request_form/verify_request_address/${queuedRegion}`
    )
};
